// extracted by mini-css-extract-plugin
export var legendIndicator = "_dh-1";
export var legendRight = "_dh-0";